import React from 'react';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import useStore from '../../store/useStore';


import {
  faBookmark,
  //faCalendar,
  //faClock,
  //faClone,
  //faCompass,
  faEnvelope,
  faFile,
  //faFloppyDisk,
  //faHandshake,
  //faListAlt
} from '@fortawesome/free-regular-svg-icons';
import {
  faCalendarPlus,
  faNoteSticky
  //faPeopleGroup,
  //faPeopleRoof
} from '@fortawesome/free-solid-svg-icons';

// @ts-ignore
import {
  CalendarHeatMap,
  Time,
  Location,
  Enterprise,
  Group,
  Headset,
  Document,
  Headphones,
  Event,
  UserFollow
} from '@carbon/icons-react';
import Button from '@mui/material/Button';


const StatementCardSessions = ({ data, datasource }: { data: any; datasource: any }) => {
  //console.log(data)

  const {
    
    settings: {
      params: { displayfilters },
    },
    
    //filters: { SectorSession },
  } = useStore((state: any) => ({
    
    settings: state.settings,
  
  }));

  //console.log(displayfilters)

  return (
    <div className="statementcard ituCard" data-span="4">
      <div className="statementcontent">
        <p className="statementtype">{data.MeetingType}</p>
        <p className="statementadminorg">{data.MonitorTitle}</p>

        {/**Event name*/}
        <p style={{ marginTop: '20px', color: '#6e6e6e', fontSize: '1rem' }}>
          <span style={{ verticalAlign: 'middle', display: 'inline-block' }}>
            <Event />
          </span>
          {/* adding space */}
          {'\u00A0'}
          {'\u00A0'}
          {data.EventTitle}
        </p>

        
        {/** commitee only for daily schedule */}
        {data.Committee !== undefined &&
          data.Committee !== '' ? (
          <p style={{ marginTop: '5px', color: '#6e6e6e', fontSize: '1rem' }}>
            <FontAwesomeIcon icon={faBookmark} />
            {/* adding space */}
            {'\u00A0'}
            {'\u00A0'}
            {data.Committee}

            {/** subgroup only for daily schedule */}
            {data.SubGroup !== undefined &&
              data.SubGroup !== '' ? (
              <>

                {/* adding space */}
                {'\u00A0'}
                {'/'}
                {'\u00A0'}
                {data.SubGroup}
              </>
            ) : null}
          </p>
        ) : null}



 {/**agenda items*/}
 {data.AgendaItems !== undefined && data.AgendaItems !== '' && data.AgendaItems.length > 0 ?
          (
            <p style={{ marginTop: '5px', color: '#6e6e6e', fontSize: '1rem' }}>
              <Document />
              {/* adding space */}
              {'\u00A0'}{'\u00A0'}
              {JSON.stringify(data.AgendaItems).replace(/"/g, '').replace('[', '').replace(']', '')}
            </p>
          )
          :
          null
        }



        {/**Date*/}
        <p style={{ marginTop: '5px', color: '#6e6e6e', fontSize: '1rem' }}>
          <span style={{ verticalAlign: 'middle', display: 'inline-block' }}>
            <CalendarHeatMap />
          </span>
          {/* adding space */}
          {'\u00A0'}
          {'\u00A0'}
          {data.DateSession}
        </p>

        {/**Time start and time end to only for social events*/}
        {data.TimeSessionStartEnd !== '' || data.TimeSession !== '' ? (
          <p style={{ marginTop: '5px', color: '#6e6e6e', fontSize: '1rem' }}>
            <span style={{ verticalAlign: 'middle', display: 'inline-block' }}>
              <Time />
            </span>
            {/* adding space */}
            {'\u00A0'}
            {'\u00A0'}

            {/** end time only for social events */}
            {data.TimeSessionStartEnd}
          </p>
        ) : null}

        {data.SectorSession !== '' && displayfilters?.sectorsession === 1  ? (
          <p style={{ marginTop: '5px', color: '#6e6e6e', fontSize: '1rem' }}>
            <span style={{ verticalAlign: 'middle', display: 'inline-block' }}>
              <Group />
            </span>
            {/* adding space */}
            {'\u00A0'}
            {'\u00A0'}
            {data.SectorSession}
          </p>
        ) : null}

        {data.Building !== '' ? (
          <p style={{ marginTop: '5px', color: '#6e6e6e', fontSize: '1rem' }}>
            <span style={{ verticalAlign: 'middle', display: 'inline-block' }}>
              <Location />
            </span>
            {/* adding space */}
            {'\u00A0'}
            {'\u00A0'}
            {data.Building} {data.RoomName !== '' ? (
              <> / {data.RoomName}</>
            ) : null}
          </p>
        ) : null}





        {/**inviation to only for social events*/}
        {data.Type === 'Social Event' && data.Message !== undefined && data.Message !== '' ? (
          <p style={{ marginTop: '5px', color: '#6e6e6e', fontSize: '1rem' }}>
            <FontAwesomeIcon icon={faEnvelope} />
            {/* adding space */}
            {'\u00A0'}
            {'\u00A0'}
            {data.Message}
          </p>
        ) : null}


       
        {/**notes  only for social events*/}
        {data.Type === 'Social Event' && data.Notes !== undefined && data.Notes !== '' ?
          (
            <p style={{ marginTop: '5px', color: '#6e6e6e', fontSize: '1rem' }}>
              <FontAwesomeIcon icon={faFile} />
              {/* adding space */}
              {'\u00A0'}{'\u00A0'}
              {data.Notes}
            </p>
          )
          :
          null
        }





      </div>

      <div style={{ color: '#6e6e6e', fontSize: '1rem', marginRight: '24px', marginBottom: '24px', marginLeft: 'auto' }}>
        <span style={{ verticalAlign: 'middle', display: 'inline-block' }}>

        </span>
        {/* adding space */}
        {'\u00A0'}
        {'\u00A0'}

        <span
          style={{
            float: 'right',
            verticalAlign: 'middle',
            textAlign: 'right',
            display: 'inline-block'
          }}>

          {/** joinURL */}
          {data.JoinURL !== undefined &&
            data.JoinURL !== '' ? (
            <a className="ituBtn" title='Join the session' href={data.JoinURL} target="_blank" rel="noreferrer" style={{ padding: '0.1rem 0.3rem', paddingTop: '8px', border: '1px solid #0076a1', display: 'initial' }}><Headset style={{ fill: '#009cd6', margin: '0px' }} /></a>
          ) : null}

          {/* adding space */}
          {'\u00A0'}
          {'\u00A0'}

          {/** RegisterURL */}
          {data.RegisterURL !== undefined &&
            data.RegisterURL !== '' ? (
            <a className="ituBtn" title='Register to the session' href={data.RegisterURL} target="_blank" rel="noreferrer" style={{ padding: '0.1rem 0.3rem', paddingTop: '8px', border: '1px solid #0076a1', display: 'initial' }}><UserFollow style={{ fill: '#009cd6', margin: '0px' }} /></a>
          ) : null}

          {/* adding space */}
          {'\u00A0'}
          {'\u00A0'}

          {/** Agenda */}
          {data.DocumentNumber !== undefined &&
            data.DocumentNumber !== '' ? (
            <a className="ituBtn" title='Download agenda' href={'https://www.itu.int/md/' + data.DocumentNumber} target="_blank" rel="noreferrer" style={{ padding: '0.1rem 0.3rem', paddingTop: '8px', border: '1px solid #0076a1', display: 'initial' }}><Document style={{ fill: '#009cd6', margin: '0px' }} /></a>
          ) : null}



        </span>
      </div>




    </div>
  );
};

export default StatementCardSessions;
